import React from "react";

const QuranRecitationControls = ({
  isVisible,
  uiLabels,
  onLaunchRecitation,
  firstVerseKeyOnPage,
  onOpenReaderPicker,
  readerLabel,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="quran-commands-recitation"
      dir="ltr"
      onClick={(event) => event.stopPropagation()}
      onPointerUp={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className="quran-commands-recitation-play"
        aria-label={uiLabels.launchRecitation}
        title={uiLabels.launchRecitation}
        onClick={onLaunchRecitation}
        disabled={!firstVerseKeyOnPage}
      >
        <i className="bi bi-play-fill quran-recitation-play-icon" aria-hidden="true" />
      </button>
      <button
        type="button"
        className="quran-commands-recitation-reader quran-commands-recitation-reader-btn"
        aria-label={uiLabels.chooseReader}
        title={uiLabels.chooseReader}
        onClick={onOpenReaderPicker}
      >
        {readerLabel}
      </button>
      <button
        type="button"
        className="quran-commands-recitation-caret"
        aria-label={uiLabels.chooseReader}
        title={uiLabels.chooseReader}
        onClick={onOpenReaderPicker}
      >
        <span className="quran-icon-glyph">▾</span>
      </button>
    </div>
  );
};

export default QuranRecitationControls;